<template>

  <ValidationObserver v-slot="{ invalid }">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <h3 class="text-primary"> {{ $t('vdo-set.vdo-set-unit') }} </h3>
        </div>

        <div class="vx-col w-1/2">
          <!--          <vx-tooltip :text="$t('general.add') + $t('vdo-set.vdo-set-unit')" class="float-right">
                      <vs-button
                        @click="onAddClick"
                        class="ml-2"
                        color="primary" icon="icon-plus" icon-pack="feather" radius size="small"
                        type="filled"></vs-button>
                    </vx-tooltip>-->

          <vx-tooltip :text="$t('general.edit') + $t('vdo-set.vdo-set-unit')" class="float-right">
            <vs-button
              v-if="selectedCourseOutlineUnit.id && !isAdd"
              @click="onEditClick"
              class="ml-2"
              color="primary" icon="icon-edit" icon-pack="feather" radius size="small"
              type="filled"></vs-button>
          </vx-tooltip>

        </div>
      </div>

      <vs-divider/>

      <div class="vx-row w-full mb-2" v-if="!showEditForm">
        <!--UNIT SELECTOR-->
        <div class="vx-col sm:w-3/5 w-full">
          <div class="v-row">
            <ValidationProvider :name="$t('vdo-set.vdo-set-unit')" rules="required" v-slot="{ errors }">
              <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :clearable="false"
                        :name="$t('vdo-set.vdo-set-unit')"
                        :options="courseOutlineUnits"
                        label="nameLocal"
                        class="w-full mb-3"
                        selectOnTab
                        v-model="selectedCourseOutlineUnit">

                <template #selected-option="{ seq, nameLocal }">
                  {{ seq }}. {{ nameLocal }}
                </template>
                <!--option list-->
                <template v-slot:option="option">
                  {{ option.seq }}. {{ option.nameLocal }}
                </template>

              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>


          <!--DESCRIPTION-->
          <div class="v-row mt-3" v-if="!showEditForm && selectedCourseOutlineUnit.descriptionLocal">
            <h6>{{ $t('course-outline.unit-description') }} </h6>
<!--            <p>{{ selectedCourseOutlineUnit.descriptionLocal }}</p>-->
            <vs-textarea
              disabled="disabled"
              rows="3"
              v-model="selectedCourseOutlineUnit.descriptionLocal"/>
          </div>


        </div>

        <!-- PRE TEST POST TEST -->
        <div class="vx-col sm:w-2/5 w-full">
          <div class="flex justify-between text-center">

            <span>
              <p class="text-xl font-semibold">{{ preTestScore }}</p>
              <p class="text-grey">{{ $t('course-outline.pre-test') }}</p>
            </span>

            <span>
              <p class="text-xl font-semibold">{{ postTestScore }}</p>
              <p class="text-grey">{{ $t('course-outline.post-test') }}</p>
            </span>

            <span>
              <p class="text-xl font-semibold">
                <feather-icon :icon="selectedCourseOutlineUnit.countLearnPercent ? 'CheckIcon':'XIcon'"
                              svgClasses='h-6 w-6'/>
              </p>
              <p class="text-grey">{{ $t('course-outline.count-learn-percent') }}</p>
            </span>

          </div>

        </div>
      </div>

      <!--EDIT UNIT SEQ-->
      <div class="vx-row" v-if="showEditForm">
        <div class="vx-col sm:w-2/5 w-full">
          <ValidationProvider :name="$t('course-outline.unit-seq')" rules="required|numeric"
                              v-slot="{ errors }">
            <vs-input :label="$t('course-outline.unit-seq') + ' *'" class="w-full"
                      disabled="disabled"
                      v-model.number="courseOutlineUnitEdit.seq"/>
            <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="vx-col sm:w-1/5 w-full">
          <ValidationProvider :name="$t('course-outline.pre-test')" rules="required|numeric|min:0"
                              v-slot="{ errors }">
            <vs-input :label="$t('course-outline.pre-test') + ' *'" class="w-full"
                      v-model.number="courseOutlineUnitEdit.preTestExpectScore"/>
            <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="vx-col sm:w-1/5 w-full">
          <ValidationProvider :name="$t('course-outline.post-test')" rules="required|numeric|min:0"
                              v-slot="{ errors }">
            <vs-input :label="$t('course-outline.post-test') + ' *'" class="w-full"
                      v-model.number="courseOutlineUnitEdit.postTestExpectScore"/>
            <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="vx-col sm:w-1/5 w-full pt-6">
          <vs-checkbox v-model="courseOutlineUnitEdit.countLearnPercent"
                       disabled="disabled">
            {{ $t('course-outline.count-learn-percent') }}
          </vs-checkbox>
        </div>

      </div>

      <!--EDIT UNIT NAME-->
      <div class="vx-row mt-3" v-if="showEditForm">

        <div class="vx-col sm:w-1/2 w-full">
          <ValidationProvider :name="$t('course-outline.unit-name-local')" rules="required"
                              v-slot="{ errors }">
            <vs-input :label="$t('course-outline.unit-name-local') + ' *'" class="w-full"
                      v-model="courseOutlineUnitEdit.nameLocal"/>
            <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="vx-col sm:w-1/2 w-full">
          <vs-input :label="$t('course-outline.unit-name-eng')" class="w-full"
                    v-model="courseOutlineUnitEdit.nameEng"/>
        </div>

      </div>

      <!--EDIT UNIT DESCRIPTION-->
      <div class="vx-row mt-3" v-if="showEditForm">

        <div class="vx-col sm:w-1/2 w-full">
          <label class="text-sm">{{ $t('course-outline.unit-description-local') }}</label>
          <vs-textarea rows="3" v-model="courseOutlineUnitEdit.descriptionLocal"/>
        </div>

        <div class="vx-col sm:w-1/2 w-full">
          <label class="text-sm">{{ $t('course-outline.unit-description-eng') }}</label>
          <vs-textarea rows="3" v-model="courseOutlineUnitEdit.descriptionEng"/>
        </div>

      </div>

      <!-- UNIT AGENDA OBJECTIVE & REFERENCE -->
      <div class="vx-row w-full mb-2">

        <div class="vx-col sm:w-1/3 w-full">
          <!--          <vx-card cardBorder noShadow>-->
          <h6 class="mb-3">{{ $t('course-outline.unit-agenda') }}</h6>

          <!--            <p class="text-grey" v-if="!showEditForm">{{unitAgenda}}</p>-->
          <vs-textarea v-if="!showEditForm"
                       rows="4"
                       disabled="disabled"
                       :value="unitAgenda"/>

          <vs-textarea rows="4" v-else
                       v-model="courseOutlineUnitEdit.unitAgenda"/>
          <!--          </vx-card>-->
        </div>

        <div class="vx-col sm:w-1/3 w-full">
          <!--          <vx-card cardBorder noShadow>-->
          <h6 class="mb-3">{{ $t('course-outline.unit-objective') }}</h6>

<!--          <p class="text-grey" v-if="!showEditForm">{{ unitObjective }}</p>-->
          <vs-textarea v-if="!showEditForm"
                       rows="4"
                       disabled="disabled"
                       :value="unitObjective"/>

          <vs-textarea rows="4" v-else v-model="courseOutlineUnitEdit.unitObjective"/>
          <!--          </vx-card>-->
        </div>

        <div class="vx-col sm:w-1/3 w-full">
          <!--          <vx-card cardBorder noShadow>-->
          <h6 class="mb-3">{{ $t('course-outline.unit-reference') }}</h6>

<!--          <p class="text-grey" v-if="!showEditForm">{{ unitReference }}</p>-->
          <vs-textarea v-if="!showEditForm"
                       rows="4"
                       disabled="disabled"
                       :value="unitReference"/>

          <vs-textarea rows="4" v-else v-model="courseOutlineUnitEdit.unitReference"/>
          <!--          </vx-card>-->
        </div>
      </div>


      <!-- Actions Button -->
      <div class="vx-row" v-if="showEditForm">
        <div class="vx-col w-full">
          <vs-button :disabled="local.isProcessing || invalid"
                     @click.prevent="onSaveClick">
            {{ $t('general.save') }}
          </vs-button>

          <vs-button @click.prevent="onCancelClick" class="ml-2" color="warning"
                     type="border">
            {{ $t('general.cancel') }}
          </vs-button>

          <!--          <vs-button v-if="selectedCourseOutlineUnit.id" @click.prevent="onDeleteClick" class="float-right" color="danger">
                      {{ $t('general.delete') }}
                    </vs-button>-->

        </div>
      </div>

    </vx-card>
  </ValidationObserver>

</template>

<script>
import {state} from '../data';
import vSelect from 'vue-select';
import {showStateNotification} from "@/utils/notification";
import {confirmDelete} from '@/utils/dialogs'

import CourseOutlineUnit from '@/store/modules/vdo-set/vdo-set/index';
import {createNamespacedHelpers} from "vuex";
import {createHelpers} from "vuex-map-fields";

if (!state.store.CourseOutlineUnit) state.registerModule(`CourseOutlineUnit`, CourseOutlineUnit);

const {
  mapActions: mapCourseOutlineUnitActions,
} = createNamespacedHelpers(`CourseOutlineUnit`);

const {
  mapFields: mapCourseOutlineUnitFields,
} = createHelpers({
  getterType: `CourseOutlineUnit/getField`,
  mutationType: `CourseOutlineUnit/updateField`,
});

export default {
  props: {
    courseOutline: Object
  },
  components: {
    vSelect,
  },
  data() {
    return {
      store: state.store,
      local: state.local,

      selectedCourseOutlineUnit: {},

      courseOutlineUnitEdit: {
        seq: null,
        nameLocal: null,
        nameEng: null,
        descriptionLocal: null,
        descriptionEng: null,
        preTestExpectScore: 20,
        postTestExpectScore: 20,
        unitAgenda: null,
        unitObjective: null,
        unitReference: null,
        countLearnPercent: true,
      },

      showEditForm: false,

      isAdd: false,
    }
  },
  computed: {
    ...mapCourseOutlineUnitFields({
      courseOutlineUnitProcessing: 'processing',
      courseOutlineUnitSuccess: 'success',
      courseOutlineUnitError: 'error'
    }),
    courseOutlineUnits() {
      return this.courseOutline ? this.courseOutline.courseOutlineUnits : [];
    },
    preTestScore() {
      return this.selectedCourseOutlineUnit.preTestExpectScore ?
        this.selectedCourseOutlineUnit.preTestExpectScore : '-';
    },
    postTestScore() {
      return this.selectedCourseOutlineUnit.postTestExpectScore ?
        this.selectedCourseOutlineUnit.postTestExpectScore : '-';
    },
    unitAgenda() {
      return this.selectedCourseOutlineUnit.unitAgenda ?
        this.selectedCourseOutlineUnit.unitAgenda : this.$t('course-outline.no-data');
    },
    unitObjective() {
      return this.selectedCourseOutlineUnit.unitObjective ?
        this.selectedCourseOutlineUnit.unitObjective : this.$t('course-outline.no-data');
    },
    unitReference() {
      return this.selectedCourseOutlineUnit.unitReference ?
        this.selectedCourseOutlineUnit.unitReference : this.$t('course-outline.no-data');
    },
  },
  watch: {
    courseOutlineUnitProcessing(data) {
      this.local.isProcessing = data;
    },
    courseOutlineUnitSuccess(data) {
      showStateNotification(this.$vs, data);
    },
    courseOutlineUnitError: async function (data) {
      showStateNotification(this.$vs, data);
    },
  },
  methods: {
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapCourseOutlineUnitActions({
      addCourseOutlineUnit: 'addCourseOutlineUnit',
      updateCourseOutlineUnit: 'updateCourseOutlineUnit',
      deleteCourseOutlineUnit: 'deleteCourseOutlineUnit',
    }),
    //---------------------------------------- Event Function ------------------------------------------------------//
    onAddClick() {
      this.showEditForm = true;
      this.isAdd = true;

      this.courseOutlineUnitEdit = {
        seq: this.courseOutline.courseOutlineUnits.length + 1,
        nameLocal: '',
        nameEng: '',
        descriptionLocal: '',
        descriptionEng: '',
        preTestExpectScore: 20,
        postTestExpectScore: 20,
        unitAgenda: '',
        unitObjective: '',
        unitReference: '',
        countLearnPercent: true,
      }
    },
    onEditClick() {
      this.showEditForm = true;
      this.isAdd = false;

      this.courseOutlineUnitEdit = {
        id: this.selectedCourseOutlineUnit.id,
        seq: this.selectedCourseOutlineUnit.seq,
        nameLocal: this.selectedCourseOutlineUnit.nameLocal,
        nameEng: this.selectedCourseOutlineUnit.nameEng,
        descriptionLocal: this.selectedCourseOutlineUnit.descriptionLocal,
        descriptionEng: this.selectedCourseOutlineUnit.descriptionEng,
        preTestExpectScore: this.selectedCourseOutlineUnit.preTestExpectScore,
        postTestExpectScore: this.selectedCourseOutlineUnit.postTestExpectScore,
        unitAgenda: this.selectedCourseOutlineUnit.unitAgenda,
        unitObjective: this.selectedCourseOutlineUnit.unitObjective,
        unitReference: this.selectedCourseOutlineUnit.unitReference,
        countLearnPercent: this.selectedCourseOutlineUnit.countLearnPercent,
      }
    },
    async onDeleteClick() {
      let payload = {
        id: this.selectedCourseOutlineUnit.id
      }
      confirmDelete(this.$vs, this.removeCourseOutlineUnit, payload);
    },
    async onSaveClick() {
      let payload = {
        courseOutlineUnitInput: {
          seq: this.courseOutlineUnitEdit.seq,
          nameLocal: this.courseOutlineUnitEdit.nameLocal,
          nameEng: this.courseOutlineUnitEdit.nameEng,
          descriptionLocal: this.courseOutlineUnitEdit.descriptionLocal,
          descriptionEng: this.courseOutlineUnitEdit.descriptionEng,
          preTestExpectScore: this.courseOutlineUnitEdit.preTestExpectScore,
          postTestExpectScore: this.courseOutlineUnitEdit.postTestExpectScore,
          unitAgenda: this.courseOutlineUnitEdit.unitAgenda,
          unitObjective: this.courseOutlineUnitEdit.unitObjective,
          unitReference: this.courseOutlineUnitEdit.unitReference,
          countLearnPercent: this.courseOutlineUnitEdit.countLearnPercent,
        }
      }

      let result;
      if (this.courseOutlineUnitEdit.id) {
        payload['id'] = this.courseOutlineUnitEdit.id;
        result = await this.updateCourseOutlineUnit(payload);
      } else {
        payload['courseOutlineId'] = this.courseOutline.id;
        result = await this.addCourseOutlineUnit(payload);
      }

      if (result) {
        result = JSON.parse(JSON.stringify(result));
        if (payload.id) {
          const index = this.courseOutline.courseOutlineUnits.findIndex(item => item.id === result.id);
          this.courseOutline.courseOutlineUnits[index] = result;
        } else {
          this.courseOutline.courseOutlineUnits.push(result);
        }

        //set selected item
        this.selectedCourseOutlineUnit = result;

        this.showEditForm = false;
        this.isAdd = false;
      }

    },
    onCancelClick() {
      this.showEditForm = false;
      this.isAdd = false;
    },
    //---------------------------------------- Local Function ------------------------------------------------------//
    async removeCourseOutlineUnit(payload) {
      let result = this.deleteCourseOutlineUnit(payload);

      if (result) {
        const index = this.local.courseOutline.courseOutlineUnits.findIndex(item => item.id === result.id);
        this.local.courseOutline.courseOutlineUnits.splice(index, 1);
        this.selectedCourseOutlineUnit = {};

        this.isAdd = false;
        this.showEditForm = false;
      }

    }
  },
}
</script>

<style scoped>

</style>
